
var Model = require("../types/Model.js");

module.exports = Model({
	name: "manageddefinitionworkflow",
	init: init,
	triggers: triggers,

	_definitions: null,
});

function init() {
	this.push([]);
}

function triggers() {
	return {
		"load": handle_load,
		"reset": handle_reset
	};
}

function handle_load(data) {
	var managee = data.who;
	var group = data.group;

	if(!managee)
		return console.error("Missing data");

	this.emit("save:trigger:start");
	this.api.manage.workflow
		.definitions(managee, group)
		.then(handle_loaded.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function handle_loaded(list) {
	this.push(list);
}

function handle_reset() {
	this.push([]);
}

function finish_load() {
	this.emit("save:trigger:finish");
}